import { useSetting } from '@/contexts/CompanyContext';
// import { mediaUrl } from '@/utils/mediaUtils';
import React from 'react';

interface IProps {
  titleEn: string;
  titleTh: string;
  description: string;
  businessUnitLogo?: number;
  otherDescription?: string;
}

const TemplateHeader = ({
  description,
  titleEn,
  titleTh,
  // businessUnitLogo,
  otherDescription,
}: IProps) => {
  const { setting } = useSetting();
  // const [logo, setLogo] = useState<string>('');
  // useEffect(() => {
  //   const fetchLogoUrl = async () => {
  //     if (businessUnitLogo) {
  //       const url = await mediaUrl({ id: businessUnitLogo || 0 });
  //       setLogo(url || '');
  //     }
  //   };

  //   fetchLogoUrl();
  // }, [businessUnitLogo]);
  return (
    <div className="flex flex-row w-full gap-5 mt-2 border-y border-black mb-8 pt-2 pb-2">
      <div className="flex w-full flex-col gap-2">
        <div className="flex justify-between flex-row gap-2">
          <div className="flex flex-col justify-start text-sm">
            <div className="font-bold">{`${setting?.companyNameEn || ''}`}</div>
            <div>{`${setting?.companyName || ''}`}</div>
            <div className="text-xs mt-1">{`${setting?.companyAddress || ''}`}</div>
          </div>
          <div className="font-bold flex flex-col justify-start text-right min-w-[250px]">
            <div className="text-lg">{titleEn}</div>
            <div>{`${titleTh} ${description && `(${description})`}`}</div>
            {otherDescription && <div>{`${otherDescription}`}</div>}
          </div>
        </div>
        <div className="flex flex-row justify-between text-xs">
          <div className="flex flex-row gap-3">
            <div>{`Tel: ${setting?.companyPhoneNumber || ''}`}</div>
            <div>{`Fax: ${setting?.companyPhoneFax || ''}`}</div>
          </div>
          <div>{`Tax ID: ${setting?.companyTaxId || ''} (สำนักงานใหญ่)`}</div>
        </div>
      </div>
    </div>
  );
};

export default TemplateHeader;
